import { styled } from "../theme";
/**
 * A circular badge component for displaying notifications or counts.
 * It has a vibrant orange background with white text, styled to be a
 * perfect circle.
 */
export const Badge = styled.div `
  display: flex;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.deepOrange100};
  color: ${({ theme }) => theme.color.white};
  font-size: 12px;
  font-weight: 500;
  justify-content: center;
`;
